export default {
  "depositRecord.title": "存款记录",
  "depositRecord.action.details": "详情",
  "depositRecord.action.export": "导出用户列表",
  "depositRecord.copy.success": "复制成功",
  "depositRecord.tooltip.copy.userNo": "复制用户编号: {text}",
  "depositRecord.tooltip.copy.orderNo": "复制订单号: {text}",
  "depositRecord.tooltip.copy.merOrderNo": "复制商户订单号: {text}",
  "depositRecord.tooltip.showUserDetails": "显示用户详情",
  "depositRecord.modal.title.details": "详情",
  "depositRecord.modal.title.userDetails": "用户详情",
  "depositRecord.modal.title.exportList": "导出列表",
  "depositRecord.column.no": "#序号",
  "depositRecord.column.orderNo": "订单号",
  "depositRecord.column.merOrderNo": "商户订单号",
  "depositRecord.column.userNo": "用户编号",
  "depositRecord.column.whatsapp": "Whatsapp",
  "depositRecord.column.email": "邮箱",
  "depositRecord.column.amount": "金额(R$)",
  "depositRecord.column.platform": "平台",
  "depositRecord.column.bonusTitle": "奖金标题",
  "depositRecord.column.bonus": "奖金",
  "depositRecord.column.rollover": "流水要求",
  "depositRecord.column.returnDays": "返还天数",
  "depositRecord.column.alreadyReturnDays": "已返还天数",
  "depositRecord.column.orderStatus": "订单状态",
  "depositRecord.column.firstName": "名",
  "depositRecord.column.lastName": "姓",
  "depositRecord.column.nickName": "昵称",
  "depositRecord.column.source": "来源",
  "depositRecord.column.channel": "渠道",
  "depositRecord.column.cpf": "CPF",
  "depositRecord.column.accountName": "账户名称",
  "depositRecord.column.createTime": "创建时间",
  "depositRecord.column.registerTime": "注册时间",
  "depositRecord.column.action": "操作",
  "depositRecord.search.createTime": "创建时间",
  "depositRecord.search.userNo": "用户编号",
  "depositRecord.search.orderNo": "订单号",
  "depositRecord.search.merOrderNo": "商户订单号",
  "depositRecord.search.channel": "渠道",
  "depositRecord.search.orderStatus": "订单状态",
  "depositRecord.search.platform": "平台",
  "depositRecord.search.bonus": "奖金",
  "depositRecord.search.amount": "金额",
  "depositRecord.search.orderTimes": "订单次数",
  "depositRecord.search.source": "来源",
  "depositRecord.search.whatsapp": "Whatsapp",
  "depositRecord.export.title": "邮件标题",
  "depositRecord.export.content": "邮件内容",
  "depositRecord.export.email": "邮箱",
  "depositRecord.export.title.default": "存款管理导出",
  "depositRecord.export.content.default": "存款管理文件",
};